'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _productSearch = require('./product-search.html');

var _productSearch2 = _interopRequireDefault(_productSearch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _productSearch2.default,
  bindings: {
    animalTypes: '<',
    searchCriteria: '<',
    searchCriteriaChanged: '&',
    searchTypes: '<'
  },
  controller: function () {
    function ProductSearchComponent(EventEmitter) {
      'ngInject';

      _classCallCheck(this, ProductSearchComponent);

      Object.assign(this, { EventEmitter: EventEmitter });
    }

    _createClass(ProductSearchComponent, [{
      key: '$onChanges',
      value: function $onChanges(changes) {
        if (changes.searchCriteria) {
          this.searchCriteria = Object.assign({}, this.searchCriteria);
        }
      }
    }, {
      key: 'onChange',
      value: function onChange() {
        this.searchCriteriaChanged(this.EventEmitter({
          searchCriteria: this.searchCriteria
        }));
      }
    }, {
      key: 'selectedUserIngredientChanged',
      value: function selectedUserIngredientChanged($event) {
        this.searchCriteria.selectedUserIngredient = $event.selectedIngredient;
        this.onChange();
      }
    }, {
      key: 'selectedSystemIngredientChanged',
      value: function selectedSystemIngredientChanged($event) {
        this.searchCriteria.selectedSystemIngredient = $event.selectedIngredient;
        this.onChange();
      }
    }, {
      key: 'selectedMemberChanged',
      value: function selectedMemberChanged($event) {
        this.searchCriteria.selectedCompany = $event.company;
        this.onChange();
      }
    }]);

    return ProductSearchComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/products/product-search/product-search.component.js